import cn from 'classnames';

/* Styles */
import styles from 'styles/tag.module.scss';

/* Assets */
import close from 'assets/images/Close.svg';

const Tag =({text, type, onClick, clickable = true}) =>{
  return(
      <div className={cn({
        [styles.tag]: true,
        [styles.careerType]: type === 'career',
        [styles.jobType]: type === 'job',
        [styles.filterType]: type === 'filter'
      })} onClick={onClick}>
        <span className={styles.text}>{text}</span>
        {type === 'filter' && (
          <span onClick={onClick} className={styles.closeLink}>
            <img alt="Close" className={styles.closeButton} src={close} />
          </span>
        )}        
      </div>
  )
}

export default Tag;